const isHidden = (el) => {
    return (el.offsetParent === null);
};

export default isHidden;
